import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { FormConfiguration } from "../../configuration";
import SelectInput from "./SelectInput";
import { mobile } from "../mediaQueries";

const styles = (theme) => ({
  root: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: "2px",
    paddingRight: "19px",
    paddingLeft: "10px",
    marginBottom: "1rem",
    cursor: "none !important",

    [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
      flexDirection: "column",
      padding: "0",
      paddingRight: "9px",
    },
  },
});

const useStyles = makeStyles(styles);

export default function Selectors() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <SelectInput
        label="Paese"
        name="paese"
        menuItems={FormConfiguration.paesi}
        style={{ cursor: "none" }}
      />
      <SelectInput
        label="Citta"
        name="citta"
        style={{ cursor: "none" }}
        menuItems={FormConfiguration.citta}
      />
      <SelectInput
        label="CAP"
        name="cap"
        menuItems={FormConfiguration.cap}
        style={{ cursor: "none" }}
      />
    </div>
  );
}
